import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'
import swal from 'sweetalert';

const application = Application.start()
const context = require.context('./controllers', true, /_controller\.js$/)
application.load(definitionsFromContext(context))
require("trix")



Trix.config.blockAttributes.h5 = {
  tagName: "h5",
  terminal: true,
  breakOnReturn: true,
  group: false
}
Trix.config.blockAttributes.h6 = {
  tagName: "h6",
  terminal: true,
  breakOnReturn: true,
  group: false
}

document.addEventListener("trix-initialize", function(event) {
  const toolbar = event.target.toolbarElement
  const fileToolsGroup = toolbar.querySelector(".trix-button-group--file-tools")
  if (fileToolsGroup) {
    fileToolsGroup.insertAdjacentHTML("beforeend",
      '<button type="button" class="trix-button" data-trix-attribute="h5" data-trix-key="h5" title="Heading 5">H5</button>' +
      '<button type="button" class="trix-button" data-trix-attribute="h6" data-trix-key="h6" title="Heading 6">H6</button>'
    )
  }
})